import React from 'react'

import classNames from 'classnames'

interface TextInputProps {
  label: string
  type?: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  required?: boolean
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  enterKeyHint?: string
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      type = 'text',
      placeholder,
      value,
      onChange,
      required = false,
      onKeyDown,
      enterKeyHint,
    },
    ref,
  ) => {
    const labelClass = classNames('font-semibold', 'mb-2', 'text-sm')
    const inputClass = classNames(
      'rounded-lg',
      'p-3',
      'w-full',
      'border',
      'border-gray-300',
      'focus:ring-2',
      'focus:ring-blue-500',
      'focus:border-transparent',
      'outline-none',
      {
        lowercase: type === 'email',
      },
    )

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value
      // Convertir a minúsculas si es tipo email
      onChange(type === 'email' ? newValue.toLowerCase() : newValue)
    }

    return (
      <div className="flex flex-col mb-4">
        <label className={labelClass}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        <input
          ref={ref}
          className={inputClass}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          required={required}
          {...(enterKeyHint ? ({ enterKeyHint } as any) : {})}
          autoCapitalize={type === 'email' ? 'off' : undefined}
          autoCorrect={type === 'email' ? 'off' : undefined}
        />
      </div>
    )
  },
)

TextInput.displayName = 'TextInput'

export default TextInput
